// import { Auth, API } from "aws-amplify";
import axios from "axios";
import { post, get, put, del } from "aws-amplify/api";
import { getCurrentUser } from "aws-amplify/auth";
import { fetchAuthSession, signInWithRedirect } from "aws-amplify/auth";

export async function apiQueryAxios(
  name: string,
  endpoint: string,
  payload: any
) {
  const user = await fetchAuthSession();
  const token = user.tokens?.idToken?.toString() ?? "";
  const payloadValue = {
    ...payload,
    headers: {
      Authorization: token,
      "Content-Type": "application/json",
      "Access-Control-Allow-Credentials": true,
      "Access-Control-Allow-Headers": "Content-Type",
      "Access-Control-Allow-Methods": "OPTIONS,POST,GET",
      "Access-Control-Allow-Origin": "*",
    },
  };

  const reply = await axios.get(
    "https://8wbfq62cch.execute-api.eu-west-1.amazonaws.com/default/TestFunctionCognito",
    {
      headers: {
        Authorization: token,
        "Content-Type": "application/json",
      },
    }
  );
}

export async function apiQuery(
  name: string,
  endpoint: string,
  payload: any,
  method = "POST"
) {
  const user = await fetchAuthSession();

  if (!user.tokens) {
    console.log("No tokens found");
    signInWithRedirect();
  }

  const currentUser = await getCurrentUser();

  const token = user.tokens?.idToken?.toString() ?? "";
  const payloadValue = {
    //...payload,
    headers: {
      Authorization: token,
      "Content-Type": "application/json",
    },
    body: payload,
  };
  if (method == "POST") {
    const { body } = await post({
      apiName: name,
      path: endpoint,
      options: payloadValue,
    }).response;

    try {
      if (body instanceof ReadableStream) {
        const result = await readStream(body);
        return result;
      } else {
        console.error("The response body is not a ReadableStream");
      }
    } catch (error) {
      console.log(error);
    }
  }

  if (method == "DELETE") {
    const response = await del({
      apiName: name,
      path: endpoint,
      options: payloadValue,
    });
    const body = response.response;

    return true;
    // try {
    //   if (body instanceof ReadableStream) {
    //     const result = await readStream(body);
    //     return result;
    //   } else {
    //     console.error("The response body is not a ReadableStream");
    //   }
    // } catch (error) {
    //   console.log(error);
    // }
  }
  if (method == "PUT") {
    const { body } = await put({
      apiName: name,
      path: endpoint,
      options: payloadValue,
    }).response;

    try {
      if (body instanceof ReadableStream) {
        const result = await readStream(body);
        return result;
      } else {
        console.error("The response body is not a ReadableStream");
      }
    } catch (error) {
      console.log(error);
    }
  }

  if (method == "GET") {
    const { body } = await get({
      apiName: name,
      path: endpoint,
      options: payloadValue,
    }).response;

    try {
      if (body instanceof ReadableStream) {
        const result = await readStream(body);
        return result;
      } else {
        console.error("The response body is not a ReadableStream");
      }
    } catch (error) {
      console.log(error);
    }
  }

  async function readStream(stream: ReadableStream) {
    const reader = stream.getReader();
    const decoder = new TextDecoder();
    let result = "";
    let done = false;

    while (!done) {
      const { value, done: doneReading } = await reader.read();
      done = doneReading;
      result += decoder.decode(value, { stream: !done });
    }

    try {
      return JSON.parse(result);
    } catch {
      return result;
    }
  }
}
